import { CHAT_SETTINGS_QUERY_KEY } from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { projectApi } from "@/api/services";

export const useChatSettings = (enabled: boolean) => {
  return useQuery({
    queryKey: [CHAT_SETTINGS_QUERY_KEY],
    queryFn: async () => projectApi.getProjectChatSettings(),
    enabled,
  });
};
